import { Modal } from 'antd';
import styled from 'styled-components';

export default styled.div`
  && {
    .backToScreenPrev {
      padding-left: 65px;
      background-color: rgba(193, 225, 141, 1);
      height: 30px;
    }
    .headerMini {
      background-color: rgba(236, 255, 184, 1);
      padding: 0 65px;
    }
    .cpap-body {
      position: relative;
      .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99;
        background: rgba(255, 255, 255, 0.8);
      }
    }
    .section {
      padding: 55px 65px;
      background: white;
      .content {
        background: #f4f4f4;
        padding: 30px;
        margin-bottom: 40px;
        .disable {
          width: 100%;
          height: 32px;
          background: #dddddd;
        }
        .nonError {
          .ant-form-item {
            margin-bottom: 0;
          }
          .bb {
            border-bottom: 1px solid #dddddd;
            margin-bottom: 5px;
            padding-bottom: 8px;
            :last-child {
              border: none;
            }
          }
        }
      }
      .content1 {
        background: #f4f4f4;
        padding: 30px 30px 5px 30px;
        margin-bottom: 40px;
      }
    }
    .submit {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-top: 30px;
      margin-bottom: 30px;
      .title {
        margin-bottom: 20px;
      }
      .text {
        text-align: center;
        margin-bottom: 20px;
      }
      .btn {
        width: 240px;
        height: 60px;
        :hover {
          background: white;
          color: rgba(235, 164, 80, 1);
          border: 1px solid rgba(235, 164, 80, 1);
        }
      }
    }
    .nonError {
      .ant-form-item {
        margin-bottom: 0;
      }
    }
    .pl-12 {
    }
    .nonBorder {
      padding-bottom: 5px;
      margin-bottom: 5px;
      border-bottom: 1px solid #dddddd;
      :last-child {
        border: none;
      }
    }
    .back {
      margin-right: 10px;
      color: white;
      width: 112px;
      height: 60px;
      background: #c4c4c4;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
      border-radius: 5px;
      :hover {
        border: #c4c4c4;
      }
    }
    .ant-checkbox-group {
      display: flex;
      flex-direction: column;
      .ant-checkbox-group-item {
        padding-top: 3px;
        margin-bottom: 5px;
        padding-bottom: 12px;
        border-bottom: 1px solid #dddddd;
        margin-right: 0;
        :last-child {
          border: none;
        }
      }
    }
    .mb-0 {
      padding: 0 3px;
      margin-bottom: 0;
    }
  }
`;

export const ModalPatientStyle = styled(Modal)`
  &&& {
    .ant-modal-header {
      padding: 2rem;
      background: #80a445;
      border-radius: 10px 10px 0px 0px;
    }
    .ant-modal-title {
      font-family: Hiragino Kaku Gothic Pro;
      font-style: normal;
      font-weight: bold;
      font-size: 26px;
      line-height: 39px;
      text-align: center;
      color: #ffffff;
    }
    .ant-modal-body {
      background: #eeeeee;
    }
    .ant-modal-footer {
      background: #ffffff;
      border-radius: 0px 0px 10px 10px;
    }
    .※ {
      color: rgba(255, 0, 0, 1);
      height: 18px;
      width: 12px;
      margin-right: 4px;
    }
    .form {
      background-color: rgba(238, 238, 238, 1);
      padding: 40px 30px;
    }
    .space {
      margin-right: 3px;
    }
    .titleInput {
      display: flex;
      align-items: center;
      margin-top: 8px;
    }
    .date {
      margin: 5px 5px 24px 5px;
    }
    .ant-input-search-button {
      background-color: #ff8a00;
      color: white;
      border: none;
    }
    .submit {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-top: 30px;
      margin-bottom: 30px;
      .text {
        text-align: center;
        margin-bottom: 20px;
      }
      .btn {
        width: 240px;
        height: 60px;
      }
    }
    .ant-tooltip-inner {
      color: black;
    }
    .ant-btn {
      :hover {
        background: white;
        border: 1px solid rgba(235, 164, 80, 1);
        color: rgba(235, 164, 80, 1);
      }
    }
    .content-body {
      font-family: Hiragino Kaku Gothic Pro;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      color: #000000;
    }

    .note-require span:first-child {
      color: rgba(255, 0, 0, 1);
      height: 18px;
      width: 12px;
      margin-right: 4px;
    }
    .note-require span:last-child {
      font-family: Hiragino Kaku Gothic Pro;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 21px;
      color: #000000;
    }
    .form-footer {
      .ant-btn {
        height: 60px;
        width: 139px;
        background-color: #c4c4c4;
        border: 1px solid #c4c4c4;
        color: white;
        border-radius: 5px;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
        :hover {
          color: #ff8a00;
          background: #ffffff !important;
          border: 2px solid #ff8a00 !important;
          box-sizing: border-box !important;
          box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2) !important;
        }
      }
      .btn-submit {
        margin-left: 1rem;
        width: 240px !important;
        background: #ff8a00 !important;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        :disabled {
          background: #eeeeee !important;
          box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2) !important;
        }
      }
    }
  }
`;
